import axios from 'axios'
import store  from '../store';

const legal = {
  servicesCookies: params => axios.post(`${process.env.VUE_APP_API_EXP}/legal/check_cookies.json`, params),
  ageValidate: params => axios.post(`${process.env.VUE_APP_API_EXP}/legal/check_mayor.json`, params)
}
const api = {
  coverageCustomer() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_GPS}/api/coverage?customer_id=${store.state.customer.instance.id}`
    })
  },
  getPaymentMethods() {
    let service = null;
    if(store.state.order.service) service = store.state.order.service;
    else service = '';
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API}/api/v4/payment_methods.json?supplier_id=${store.state.customer.supplier.id}&tipe=array&service=${service}`
    });
  },
  uploadFile(formData) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_API_CLUVIMKT}/api/pay_purchase_image`,
      data: formData,
      headers: {
        'content-type': 'multipart/form-data'
      }
    });
  },
  sendRating(params_id,params_token,bookRate) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_API}/rate/${params_id}/${params_token}.json`,
      data: { book_rate: bookRate }
    });
  },
  sendLogToSearch(data) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_GPS}/api/search_google_logs.json`,
      data: {search_google_log: data}
    });
  },
  getCitys() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_GPS}/api/v2/search_cities.json?customer_id=${store.state.customer.instance.id}`
    });
  },
  getInfoSucursal(supplier_id) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/api/suppliers/${supplier_id}.json`
    });
  },
  getShedules(customer) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API}/api/v4/schedules?branch_id=${customer.branch_id}`
    });
  },
  getSupplierAvailable (latitude,longitude) {
    let service = store.state.order.service === 'delivery' && store.state.order.subservice === 'schedule' ? 'schedule' : 'delivery';
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_GPS}/api/v2/supplier_availability.json?customer_id=${store.state.customer.instance.id}&service=${service}&lat=${latitude}&lon=${longitude}`
    })
  }
}
const order = {
  GetOrder(order_id){
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/api/my_purchases/${order_id}.json`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      }
    });
  },
  GetOrders() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/api/actual_purchases.json`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      }
    });
  }
}
const params = {
  getHours(schedule_date) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/params/get_hours_schedule.json?supplier_id=${store.state.customer.supplier.id}&date=${schedule_date}`
    });
  },
  getDays(branch_id) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API}/api/v4/params_to_schedule.json?branch_id=${branch_id}`
    });
  }
}

export {
  legal,
  api,
  order,
  params
}